import { SkillCategory } from '../types';
import SkillCard from './SkillCard';
import Icon from '../../../components/AppIcon';


interface SkillCategorySectionProps {
  category: SkillCategory;
}

const SkillCategorySection = ({ category }: SkillCategorySectionProps) => {
  return (
    <div className="mb-12">
      <div className="flex items-center gap-3 mb-6">
        <div
          className="w-12 h-12 rounded-lg flex items-center justify-center"
          style={{ backgroundColor: `${category.color}20` }}
        >
          <Icon name={category.icon} size={24} color={category.color} />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-foreground">{category.name}</h2>
          <p className="text-sm text-muted-foreground">{category.skills.length} skills</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {category.skills.map((skill) => (
          <SkillCard key={skill.id} skill={skill} />
        ))}
      </div>
    </div>
  );
};

export default SkillCategorySection;